const KEY = 'wiiz_session';

// Keep the current UI session locally so page refresh does not return to login.
export const getSession = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY) || 'null');
  } catch {
    return null;
  }
};

export const setSession = session => {
  localStorage.setItem(KEY, JSON.stringify(session));
};

export const clearSession = () => {
  localStorage.removeItem(KEY);
};
